import {Component, Input, OnInit} from '@angular/core';
import { orderBy } from 'lodash';

@Component({
  selector: 'app-concat-properties',
  templateUrl: './concat-properties.component.html',
  styleUrls: ['./concat-properties.component.scss']
})
export class ConcatPropertiesComponent implements OnInit {

  @Input() data: any[] = [];
  @Input() maxItems = 2;
  @Input() propertyName = 'name';
  @Input() subfixSingular = 'más';
  @Input() subfixPlural = 'más';
  @Input() truncate = false;
  constructor() { }

  ngOnInit(): void {
    if (!this.data || !this.data[0]) return;
    if (typeof this.data[0][this.propertyName] === 'string') {
      this.data = orderBy(this.data, [(item) => item[this.propertyName]?.length, this.propertyName], ['asc']);
    }
  }

}
